import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Controller from "./search.controller";
import Template from "./search.html";
import Bookings from "../../services/bookings.service";
import Customer from "../../components/customer-item/customer-item";
import Vehicles from "../../services/vehicles.service";
import Customers from "../../services/customers.service";
import WheelStorages from "../../services/wheelstorages.service";
import BookingItem from "../../components/booking-item/booking-item";
import VehicleItem from "../../components/vehicle-item/vehicle-item";
import WheelStorageItem from "../../components/wheel-storage-item/wheel-storage-item";
import WheelStorageActiveIcon from "../../components/wheel-storage-active-icon/wheel-storage-active-icon";
import WheelStorageStateIcon from "../../components/wheel-storage-state-icon/wheel-storage-state-icon";
import WheelStorageTypeIcon from "../../components/wheel-storage-type-icon/wheel-storage-type-icon";
import SearchModalDelegate from "./search.modal.service";

var SearchModule = Angular.module('search', [
    Bookings.name,
    Customers.name,
    Vehicles.name,
    WheelStorages.name,
    WheelStorageActiveIcon.name,
    WheelStorageStateIcon.name,
    WheelStorageTypeIcon.name,
    BookingItem.name,
    Customer.name,
    VehicleItem.name,
    WheelStorageItem.name])

    .component('search', {
        template: Template,
        controller: Controller,
        bindings: {
            searchType: "<",
            showTypeSelection: "<",
            showTypeSelectionBookings: "<",
            showTypeSelectionCustomers: "<",
            showTypeSelectionVehicles: "<",
            showTypeSelectionWheelStorages: "<",
            searchWithoutTerm: "<",
            showSearchTerm: "<",
            searchTerm: "<",
            bookingsFilter: "<",
            customersFilter: "<",
            vehiclesFilter: "<",
            wheelStoragesFilter: "<",
            onBookingSelected: '&',
            onCustomerSelected: '&',
            onVehicleSelected: '&',
            onWheelStorageSelected: '&'
        }
    });

new Loader(SearchModule)
    .load(SearchModalDelegate);

export default SearchModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/search/search.js